import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SettingService {

  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) { }

  getSettingData(): Observable<any> {
    return this.http.get(`${this.apiUrl}/settings`,);
  }

  updatePlatformConfig(data: any): Observable<any> {
    return this.http.patch(`${this.apiUrl}/settings/platform`, data);
  }

  updateSecuritySettings(data: any): Observable<any> {
    return this.http.patch(`${this.apiUrl}/settings/security`, data);
  }

  updateComplianceSettings(data: any): Observable<any> {
    return this.http.patch(`${this.apiUrl}/settings/compliance`, data);
  }
}
